(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('header-announcement-container');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerheight = this.headerBounds.bottom;
        if(scrollTop > headerheight){
          this.reveal();
        }

      //
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (window.innerWidth < 660) {
        // Get references to the div elements
        const sortBySelector = document.querySelector('.stickyheader--active .facets-container');
        const filterSelector = document.querySelector('.select');

        if (sortBySelector && filterSelector) {
          // Get the computed height of filterSelector
          const stickyFiltersHeight = window.getComputedStyle(filterSelector).getPropertyValue('height');
          //alert(stickyFiltersHeight);

          // Set the height of sortBySelector to match filterSelector
            sortBySelector.style.height = stickyFiltersHeight;
        }
      }
    }

    hide() {
      this.closeSearchModal();
    }

    reveal() {
      document.body.classList.add('stickyheader--active');
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('stickyheader--active');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader); 

  // FTC-60290 - Fixing Accessibility
  document.addEventListener('DOMContentLoaded', function() {
    // Handle desktop mega menus
    const megaMenus = document.querySelectorAll('.mega-menu')
    
    megaMenus.forEach((menu) => {
      const details = menu.querySelector('details')
      const content = menu.querySelector('.mega-menu__content')
      const overlay = menu.querySelector('.megamenu-overlay')
      
      if (!content) return

      let isMenuOpen = false
      let isUsingKeyboard = false

      // Function to update tabindex and visibility for all focusable elements
      function updateMegaMenuTabIndex(isOpen) {
        const focusableElements = content.querySelectorAll('a, button, input, select, textarea')
        
        focusableElements.forEach((el) => {
          if (isOpen) {
            el.removeAttribute('tabindex')
            el.removeAttribute('aria-hidden')
          } else {
            el.setAttribute('tabindex', '-1')
            el.setAttribute('aria-hidden', 'true')
          }
        })
        
        // Update container aria-hidden and visual state
        if (isOpen) {
          content.removeAttribute('aria-hidden')
          if (overlay) overlay.classList.add('active')
          // Add class to show menu when opened via keyboard
          if (isUsingKeyboard) {
            menu.classList.add('keyboard-open')
          }
        } else {
          content.setAttribute('aria-hidden', 'true')
          if (overlay) overlay.classList.remove('active')
          // Remove class when menu closes
          menu.classList.remove('keyboard-open')
        }
      }

      // Initialize - hide all links when closed
      updateMegaMenuTabIndex(false)

      // For DETAILS-based menus
      if (details) {
        details.addEventListener('toggle', function() {
          isMenuOpen = this.open
          updateMegaMenuTabIndex(this.open)
        })
      } 
      // For non-details mega menus (hover-based)
      else {
        const summary = menu.querySelector('summary, .header__menu-item')
        const focusTarget = summary.querySelector('a') || summary
        
        if (summary) {
          // Detect keyboard usage and prevent Space from scrolling
          summary.addEventListener('keydown', (e) => {
            isUsingKeyboard = true
            // Prevent spacebar from scrolling the page
            if (e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault()
            }
          })

          // Mouse hover support - only if NOT using keyboard
          menu.addEventListener('mouseenter', () => {
            if (!isUsingKeyboard) {
              isMenuOpen = true
              updateMegaMenuTabIndex(true)
            }
          })
          
          menu.addEventListener('mouseleave', () => {
            if (!isUsingKeyboard) {
              isMenuOpen = false
              updateMegaMenuTabIndex(false)
            }
          })

          // Reset keyboard flag on mouse move
          menu.addEventListener('mousemove', () => {
            if (isUsingKeyboard && !isMenuOpen) {
              isUsingKeyboard = false
            }
          })

          // Keyboard activation support (Space/Enter)
          summary.addEventListener('keydown', (e) => {
            // Space or Enter key
            if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
              e.preventDefault()
              isMenuOpen = !isMenuOpen
              updateMegaMenuTabIndex(isMenuOpen)
              
              if (isMenuOpen) {
                // Focus first link in mega menu
                const firstLink = content.querySelector('a')
                if (firstLink) {
                  setTimeout(() => firstLink.focus(), 50)
                }
              }
            }
            // Escape key closes menu
            else if (e.key === 'Escape' && isMenuOpen) {
              e.preventDefault()
              isMenuOpen = false
              updateMegaMenuTabIndex(false)
              // Focus the actual link element
              setTimeout(() => {
                focusTarget.focus()
              }, 50)
            }
          })

          // Escape key handler for when focus is inside the mega menu
          content.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
              e.preventDefault()
              isMenuOpen = false
              updateMegaMenuTabIndex(false)
              // Focus the actual link element
              setTimeout(() => {
                focusTarget.focus()
              }, 50)
            }
          })

          // Close menu when tabbing out
          menu.addEventListener('focusout', (e) => {
            // Wait a moment to see where focus goes
            setTimeout(() => {
              if (isMenuOpen && !menu.contains(document.activeElement)) {
                isMenuOpen = false
                updateMegaMenuTabIndex(false)
                // Reset keyboard flag after closing
                isUsingKeyboard = false
              }
            }, 100)
          })
        }
      }
    })
  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({note: event.target.value});
        fetch(`${
          routes.cart_update_url
        }`, {
          ...fetchConfig(),
          ...{
            body
          }
        });
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        console.log('ProductRecommendations: IntersectionObserver triggered');
        observer.unobserve(this);
        console.log('AAA');

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('.product-recommendations-section');

            if (recommendations && recommendations.innerHTML.trim().length) {
              if (this.classList.contains('cart-recommendations')) return;
              console.log("I am called", recommendations);
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
